const properties = `showWhenEventIs`

export default properties
